// extracted by mini-css-extract-plugin
export default {"container":"Step_container__7lITG","step_heading":"Step_step_heading__EXrUZ","content":"Step_content__sEb6e"};